import { Outlet } from 'react-router-dom';
import withReducer from 'app/store/withReducer';
import reducer from './store';

function ObjectItems() { 
  return <Outlet />;
}

export default withReducer('objectitems', reducer)(ObjectItems);
